"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueWrapper = exports.ShortMultiDisplay = exports.SelectContainer = exports.OptionWrapper = exports.OptionCheckboxLayer = exports.IconLeftWrapper = exports.Ellipsis = exports.CloseNovoIcon = exports.CloseIcon = exports.CheckboxWrapper = exports.AvatarIcon = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _CloseIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseIcon"));
var _CloseCircleIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/CloseCircleIcon"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13; // @ts-check
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SelectContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin-top: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeight;
}, function (_ref4) {
  var theme = _ref4.theme,
    hasLabel = _ref4.hasLabel;
  return hasLabel ? theme.marginTop : '0';
});
exports.SelectContainer = SelectContainer;
SelectContainer.displayName = 'SelectContainer';
var IconLeftWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-self: center;\n  display: flex;\n  align-items: center;\n  padding-right: ", ";\n  margin: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.iconPaddingRight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.iconMargin;
});
exports.IconLeftWrapper = IconLeftWrapper;
IconLeftWrapper.displayName = 'IconLeftWrapper';
var CloseNovoIcon = (0, _styledComponents["default"])(_CloseCircleIcon["default"])(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.icon01;
});
exports.CloseNovoIcon = CloseNovoIcon;
CloseNovoIcon.displayName = 'CloseNovoIcon';
var CloseIcon = (0, _styledComponents["default"])(_CloseIcon["default"])(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &:hover {\n    fill: ", ";\n  }\n"])), function (_ref8) {
  var isFocused = _ref8.isFocused,
    theme = _ref8.theme;
  return isFocused ? theme.clearIconFocusedHoverColor : theme.clearIconHoverColor;
});
exports.CloseIcon = CloseIcon;
CloseIcon.displayName = 'CloseIcon';
var AvatarIcon = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.avatarPaddingRight);
});
exports.AvatarIcon = AvatarIcon;
AvatarIcon.displayName = 'AvatarIcon';
var CheckboxWrapper = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  width: 100%;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.checkboxPaddingRight);
});
exports.CheckboxWrapper = CheckboxWrapper;
CheckboxWrapper.displayName = 'CheckboxWrapper';
var OptionWrapper = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  display: block;\n  max-width: 100%;\n  align-self: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n"])));
exports.OptionWrapper = OptionWrapper;
OptionWrapper.displayName = 'OptionWrapper';
var OptionCheckboxLayer = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  ", ";\n"])), function (_ref11) {
  var isDisabled = _ref11.isDisabled;
  return !isDisabled && "cursor: pointer";
});
exports.OptionCheckboxLayer = OptionCheckboxLayer;
OptionCheckboxLayer.displayName = 'OptionCheckboxLayer';
var ValueWrapper = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex: 1;\n  position: relative;\n  ", "\n  overflow: auto;\n  ", "\n  box-sizing: border-box;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n"])), function (_ref12) {
  var size = _ref12.size;
  if (size === 'small') {
    return "\n        margin: 2px 0;\n        gap: 3px;\n      ";
  }
  return "\n      margin: 6px 0;\n      gap: 6px;\n    ";
}, function (_ref13) {
  var theme = _ref13.theme,
    size = _ref13.size,
    multipleSelectMaxRows = _ref13.multipleSelectMaxRows;
  var padding = theme.multiValueChipPaddingVerticalDefault;
  var margin = '12px'; // margin top + bottom

  if (size === 'small') {
    padding = theme.multiValueChipPaddingVerticalSmall;
    // only small size has half the margin & gap
    margin = '6px';
  }
  if (size === 'large') {
    padding = theme.multiValueChipPaddingVerticalLarge;
  }

  // if single line, preserve no flex-wrapping
  if (multipleSelectMaxRows === 1) {
    return (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        flex-wrap: nowrap;\n        overflow: hidden;\n      "])));
  }

  // this calculates the height of the chip (Tag height + padding top&bottom) * max rows + top&bottom margins
  return (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      flex-wrap: wrap;\n      max-height: calc(\n        ((1.5rem + (2 * ", ")) * ", ") + ", "\n      );\n    "])), padding, multipleSelectMaxRows, margin);
});
exports.ValueWrapper = ValueWrapper;
ValueWrapper.displayName = 'ValueWrapper';
var ShortMultiDisplay = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  color: ", ";\n  position: relative;\n  padding-right: ", ";\n  max-width: calc(100% - 20px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.selectedOptionTextColor;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.shortMultiDisplayPadding;
});
exports.ShortMultiDisplay = ShortMultiDisplay;
ShortMultiDisplay.displayName = 'ShortMultiDisplay';
var Ellipsis = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  min-width: 20px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
exports.Ellipsis = Ellipsis;
Ellipsis.displayName = 'Ellipsis';